export type DynamicSmartOfferEventType = "pitch" | "fallback";

export class DynamicSmartOffer {
    toneGuidance: string;
    pitchPoints: string[];
    eventType: DynamicSmartOfferEventType;

    constructor(toneGuidance: string, pitchPoints: string[], eventType: DynamicSmartOfferEventType = "pitch") {
        this.toneGuidance = toneGuidance;
        this.pitchPoints = pitchPoints;
        this.eventType = eventType;
    }

    isValid(): boolean {
        return this.toneGuidance.length > 0 && this.pitchPoints.some((p) => p.length > 0);
    }

    isFallback(): boolean {
        return this.eventType === "fallback";
    }

    equals(other: DynamicSmartOffer): boolean {
        return (
            this.eventType === other.eventType &&
            this.toneGuidance === other.toneGuidance &&
            this.pitchPoints.length === other.pitchPoints.length &&
            this.pitchPoints.every((p, i) => p === other.pitchPoints[i])
        );
    }
}
